/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyAdherenceScoreDto
 */
export interface DailyAdherenceScoreDto {
    /**
     * 
     * @type {Date}
     * @memberof DailyAdherenceScoreDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof DailyAdherenceScoreDto
     */
    completedPoints: number | null;
    /**
     * Sum of all generated task points for this date
     * @type {number}
     * @memberof DailyAdherenceScoreDto
     */
    totalPoints: number | null;
    /**
     * 
     * @type {number}
     * @memberof DailyAdherenceScoreDto
     */
    percentage: number | null;
}

/**
 * Check if a given object implements the DailyAdherenceScoreDto interface.
 */
export function instanceOfDailyAdherenceScoreDto(value: object): value is DailyAdherenceScoreDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('completedPoints' in value) || value['completedPoints'] === undefined) return false;
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    return true;
}

export function DailyAdherenceScoreDtoFromJSON(json: any): DailyAdherenceScoreDto {
    return DailyAdherenceScoreDtoFromJSONTyped(json, false);
}

export function DailyAdherenceScoreDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyAdherenceScoreDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'completedPoints': json['completedPoints'],
        'totalPoints': json['totalPoints'],
        'percentage': json['percentage'],
    };
}

export function DailyAdherenceScoreDtoToJSON(json: any): DailyAdherenceScoreDto {
    return DailyAdherenceScoreDtoToJSONTyped(json, false);
}

export function DailyAdherenceScoreDtoToJSONTyped(value?: DailyAdherenceScoreDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': ((value['date']).toISOString().substring(0,10)),
        'completedPoints': value['completedPoints'],
        'totalPoints': value['totalPoints'],
        'percentage': value['percentage'],
    };
}

